<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="requests"
        :loading="loading"
        class="va-table va-table--hoverable va-table--clickable"
        no-data-label="Пусто"
      >
        <template slot="florist" slot-scope="props">
          <span>{{ getFloristName(props.rowData.florist_id) }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.name }}</span>
        </template>
        <template slot="phone" slot-scope="props">
          <span>{{ props.rowData.phone }}</span>
        </template>
        <template slot="email" slot-scope="props">
          <span>{{ props.rowData.email || '-' }}</span>
        </template>
        <template slot="text" slot-scope="props">
          <span>{{ truncate(props.rowData.text, 50) }}</span>
        </template>
        <template slot="created_at" slot-scope="props">
          <span>{{ formatDate(props.rowData.created_at) }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-eye"
            @click.stop="viewHandler(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click.stop="removeHandler(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="viewModal" size="large" hide-default-actions>
      <florist-request-view
        :request="currentRequest"
        @close="viewModal = false"
      />
    </va-modal>
  </div>
</template>

<script>
import api from '@/api/axios';
import FloristRequestView from './florist-request-view.vue';

export default {
  components: { FloristRequestView },
  props: {
    requests: {
      type: Array,
      require: true,
      default: () => [],
    },
    florists: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewModal: false,
      currentRequest: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:florist',
          title: 'Флорист',
        },
        {
          name: '__slot:name',
          title: 'Имя',
        },
        {
          name: '__slot:phone',
          title: 'Телефон',
        },
        {
          name: '__slot:email',
          title: 'Email',
        },
        {
          name: '__slot:text',
          title: 'Текст заявки',
        },
        {
          name: '__slot:created_at',
          title: 'Дата создания',
        },
        {
          name: '__slot:actions',
          title: '',
          width: '100px',
        },
      ];
    },
  },
  methods: {
    getFloristName(floristId) {
      const florist = this.florists.find((f) => f.id === floristId);
      return florist ? florist.name : '-';
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleString('ru-RU', { timeZone: 'Asia/Omsk' });
    },
    truncate(value, size) {
      if (!value) return '-';
      value = value.toString();
      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + '...';
    },
    viewHandler(request) {
      this.viewModal = true;
      this.currentRequest = request;
    },
    async removeHandler(id) {
      if (confirm('Вы действительно хотите удалить заявку?')) {
        try {
          await api.delete(`/admin/florist-requests/${id}`);
          this.$emit('refresh');
        } catch (error) {
          console.error('Ошибка удаления заявки:', error);
          alert('Ошибка при удалении заявки');
        }
      }
    },
  },
};
</script>

<style></style>

